// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"f766015b","496":"d20c3c7f","761":"e8dcfdc2","950":"40dbb661"}[chunkId] + ".chunk.js";
};